export default __webpack_public_path__ + "static/media/TimeToFly.e6242bfe.png";